/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from "react";


export const RowCell = ({children, sizes = {}, className}) =>
    (<div className={`table-group-cell ${Object.entries(sizes).map(s => `col-${s[0]}-${s[1]}`).join(" ")}${className ? ' ' + className : ''}`}>
        {children}
    </div>);
